// extracted by mini-css-extract-plugin
export default {"dots":"SliderPagination__dots--ig-dDe50","dot":"SliderPagination__dot--ig-pQMDm","active":"SliderPagination__active--ig-hLUI9"};